<template>
  <wrap-container>
    <section-label value="Seleccioná una de las siguientes opciones:" />

    <wrap-container class="cascade w50"></wrap-container>

    <wrap-container class="header fila grid-container grid-container--4-4-4">
      <span class="col1">Código postal</span>
      <span class="col2">Calle</span>
      <span class="col3">Nº Puerta</span>
    </wrap-container>

    <wrap-container
      class="fila grid-container grid-container--4-4-4 table localidad"
      v-for="(item, index) in options"
      :key="`select-encotesa-${index}`"
    >
      <radio-item
        class="radio col1"
        :optionValue="index"
        @input="onSelect(index)"
        :label="item.codPostal"
      />
      <p class="col2" @click="onSelect(index)">{{ item.direCalle }}</p>
      <p class="col3" @click="onSelect(index)">
        {{ item.puerta }}
      </p>
    </wrap-container>
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import SectionLabel from "@/components/core/SectionLabel";
import RadioItem from "@/components/core/custom/RadioItem";
import {
  DO_SELECT_PARTICULAR,
  DO_SELECT_ALTERNATIVO
} from "@/config/constants/action-types";

const unificarPayload = domicilioMerlin => {
  // Desde merlin los nombres de los campos son diferentes
  // unificarlos y solo retornar lo necesario
  return {
    calleLocalidad: domicilioMerlin.direCalle,
    codigoPostal: domicilioMerlin.codPostal
  };
};

export default {
  name: "AddressSelectOptions",
  components: {
    WrapContainer,
    SectionLabel,
    RadioItem
  },
  props: {
    options: Array,
    otroDomicilio: Boolean,
    step4: Boolean
  },
  methods: {
    onSelect(index) {
      if (this.step4) {
        this.$emit("selectValid");
      }
      if (this.otroDomicilio) {
        this.$store.dispatch(
          DO_SELECT_ALTERNATIVO,
          unificarPayload(this.options[index])
        );
      } else {
        this.$store.dispatch(
          DO_SELECT_PARTICULAR,
          unificarPayload(this.options[index])
        );
      }
    }
  }
};
</script>

<style scoped>
.header {
  font-size: 12px;
  font-weight: 500;
  cursor: default;
}
.fila {
  border-bottom: 1px solid #f4f4f4;
  cursor: pointer;
}
.fila > span,
.fila > div,
.fila > p {
  padding-top: 15px;
  padding-bottom: 15px;
  margin: 0;
  display: block;
}
.fila .radio {
  display: flex;
  align-items: center;
}
.fila .radio label {
  vertical-align: middle;
}
</style>
